import { render, staticRenderFns } from "./AuthorizationsValidatePage.vue?vue&type=template&id=63912344&scoped=true&"
import script from "./AuthorizationsValidatePage.vue?vue&type=script&lang=js&"
export * from "./AuthorizationsValidatePage.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizationsValidatePage.vue?vue&type=style&index=0&id=63912344&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63912344",
  null
  
)

export default component.exports